// src/pages/Campaigns.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { decodeId, encodeId } from '../../../utills/idUtils';
import CampaignTable from './CampaignTable';
import Pagination from '../Pagination';
import BasicBreadcrumbs from '../../common/Breadcrumbs';

const API_URL = process.env.REACT_APP_API_URL;

const Campaigns = () => {
    const { userId: encodedUserId } = useParams();
    const userId = decodeId(encodedUserId);

    const navigate = useNavigate()

    const [campaigns, setCampaigns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const fetchCampaigns = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${API_URL}/users/${userId}/campaigns?page=${currentPage}&limit=${rowsPerPage}`
            );
            const data = await response.json();
            setCampaigns(data.data);
            setTotalPages(data.pagination?.totalPages);
        } catch (error) {
            console.error('Error fetching campaigns:', error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCampaigns();
    }, [userId, currentPage, rowsPerPage]);

    const handleSeeDetails = (campaignId) => {
        console.log('View campaign details:', campaignId);
        // Add navigate logic if needed
        // const encodedId = encodeId(campaignId);
        // navigate(`/campaigns/${encodedId}`);
        const encodedId = encodeId(campaignId);
        navigate(`/campaign/${encodedId}/details`);
    };
    // console.log(campaigns);

    return (
        <div className="min-h-screen bg-blue-50 p-4 md:p-8">
            <div className="bg-white shadow-md rounded-lg p-6">
                <BasicBreadcrumbs/>
                <h1 className="text-2xl font-semibold mb-6 text-blue-800 opacity-0">Campaigns</h1>
                  
                {loading ? (
                    <div className="text-center py-10 text-blue-600 font-medium">Loading...</div>
                ) : (
                    <>
                        <CampaignTable campaigns={campaigns} onSeeDetails={handleSeeDetails} />

                        {totalPages >= 1 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                rowsPerPage={rowsPerPage}
                                onPageChange={(page) => setCurrentPage(page)}
                                onRowsPerPageChange={(rows) => {
                                    setRowsPerPage(rows);
                                    setCurrentPage(1); // reset to page 1 on rows change
                                }}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default Campaigns;
